import clsx from 'clsx';
import { useCarousel } from './CarouselContext';

import * as styles from './Carousel.module.css';

import type { NavigationDelta } from './types';

type CarouselControlProps = React.HTMLAttributes<HTMLButtonElement> & {
  navigationDelta: NavigationDelta;
};

export const CarouselControl: React.FC<CarouselControlProps> = ({ navigationDelta, ...props }) => {
  const { navigate } = useCarousel();

  return (
    <button
      {...props}
      className={clsx(styles.carouselControl, props.className)}
      onClick={(event) => {
        navigate(navigationDelta, 'manual');
        props.onClick?.(event);
      }}
    />
  );
};
